<h1 mat-dialog-title>Warning</h1>
<div mat-dialog-content>
  <p>{{data.query}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onDialogClose()">{{data.negativeText}}</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{data.positiveText}}</button>
</div>
